import * as React from 'react';

import { useImportModel } from 'src/containers/ProjectModelDialog/hooks/useImportModelValue';
import { useWillImportBeLarge } from 'src/containers/ProjectModelDialog/hooks/useWillImportBeLarge';

/**
 * Whether the models picked for import would put the project past the
 * large-model threshold.
 *
 * `useWillImportBeLarge` sums the project's current diagram with the incoming
 * payload, so on a project that is already over the limit an empty payload is
 * enough to make it true. Both the panel warning and the Add button's tooltip
 * describe what the user is adding, so neither has anything to say until there
 * is something to import — shared so the two cannot drift apart.
 *
 * Gated on `dataModels` rather than the raw selection, since a combo model can
 * be selected without contributing any importable data model. That is also what
 * `isAddImportedModelsEnabled` gates on, so the warning and the Add button
 * always agree on whether an import is on the table.
 */
export const useIsImportOverLimit = () => {
  const { dataModels, pendingModelData } = useImportModel();
  const willImportBeLarge = useWillImportBeLarge();

  return React.useMemo(
    () => (dataModels.length ? willImportBeLarge(pendingModelData) : false),
    [dataModels, pendingModelData, willImportBeLarge]
  );
};
